const isMacPlatform = (): boolean =>
  typeof navigator !== 'undefined' &&
  navigator.platform.toUpperCase().includes('MAC')

export const COMMAND_PALETTE_MODIFIER_LABEL = isMacPlatform() ? '⌘' : 'Ctrl'

export const COMMAND_PALETTE_SHORTCUT_LABEL = `${COMMAND_PALETTE_MODIFIER_LABEL}${isMacPlatform() ? '' : '+'}K`

/** Cmd+K on Mac, Ctrl+K elsewhere; Shift/Alt variants stay free for other features. */
export const isCommandPaletteShortcut = (event: KeyboardEvent): boolean => {
  const modifier = isMacPlatform() ? event.metaKey : event.ctrlKey
  return (
    modifier &&
    !event.shiftKey &&
    !event.altKey &&
    event.key.toLowerCase() === 'k'
  )
}
